
//opens a list of websites as new tabs (tested for chrome and firefox)
// @param string array linkArray
export function openMultipleTabs(linkArray) //param could be link array for general solution
{
	//web: https://stackoverflow.com/questions/24364117
	//web: https://stackoverflow.com/questions/9847580
	for(var k = 0; k < linkArray.length; ++k)
	{
		window.open(linkArray[k]);
	}
}

// returns numeric value, independent if parameter is string, int or float
// and converts commas to decimal points
export function forceNumeric(maybeNumeric)
{
	return Number(maybeNumeric.toString().replace(',','.'));
}

export function isValidJson(j)
{
	try
	{
		var dump = JSON.parse(j);
	}
	catch(error)
	{
		return false;
	}
	return true;
}